import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const databaseSearch = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/databaseSearch`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const applyJobThroughDatabaseSearch = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/jzs-apply-job-through-database-search`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const searchKeywords = (keyword) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/databaseSearch/keywords?keyword=${keyword}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const searchlocations = (keyword) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/databaseSearch/locations?keyword=${keyword}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const aiSuggestedKeyword = (payload) => {
    const url = `${process.env.REACT_APP_AI_URL}/v3/jobzshala/keywordGenerator`;
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
};


export const generateSearch = (payload) => {
    const url = `${process.env.REACT_APP_AI_URL}/v3/jobzshala/databaseSearchFormAutoFiller`;
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const highestQualification = (keyword) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/databaseSearch/highest_qualification`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};

export const profileDetail = (candidate_id) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh/databaseSearch/profile-detail/${candidate_id}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
};
